<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="班级名称"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        style="width:150px;"
                        v-model="form.workDate"
                        type="datetime"
                        placeholder="录播日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="title" label="标题" width="100"></el-table-column>
                <el-table-column prop="updateBy" label="视频作者" width="100"></el-table-column>
                <el-table-column prop="courseName" label="第几节课" width="100"></el-table-column>
                <el-table-column prop="timeSlot" label="录播时间段" width="100"></el-table-column>
                <el-table-column prop="videoTime" label="录播时长" width="100"></el-table-column>
                <el-table-column prop="videoUrl" label="视频" width="100">
                    <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.videoUrl">查看录播</a>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0">
                            未编辑
                        </div>
                        <div v-else-if="scope.row.status == 1">
                            待分享
                        </div>
                        <div v-else-if="scope.row.status == 2">
                            已分享
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column> 
                <el-table-column prop="playCount" label="播放次数" width="100"></el-table-column>
                <el-table-column prop="supportCount" label="点赞次数" width="100"></el-table-column>
                <el-table-column prop="" label="分享班级" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.shareUser != null && scope.row.shareUser != ''">
                            {{scope.row.className}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="shareUser" label="发起分享人" width="100"></el-table-column>
                <el-table-column prop="gmtCreate" label="生成时间" width="100"></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';

    export default {
        name:"ClassVideo",
        data(){
            return{
                menuName:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    className:"",
                    deptId:"",
                    workDate:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listClassroomVideoUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    className:this.form.className,
                    gmtCreate:(this.form.workDate==null?"":this.form.workDate),
                    deptId:this.form.deptId
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.trafficRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/class/ClassVideo.vue